import { Etiqueta } from '@shared/models';

export class CustomFeatureSectionDTO {
    nombre: string;
    etiquetas: Etiqueta[];
    //funcionalidadesPersonalizadas: FuncionalidadPersonalizacionDTO[]; 
}